(function($, Drupal, window, document) {
  "use strict";

  // Example of Drupal behavior loaded.
  Drupal.behaviors.menu = {
    attach: function menuMountAllison(context, settings) {
      if (typeof context["location"] !== "undefined") {
        // Only fire on document load.

        /*
         * Scroll pin
         */

        $(window).on("load", function() {
          var hasFixedAdminToolbar = $("body").hasClass("toolbar-fixed");
          var adminToolbarHeight = hasFixedAdminToolbar
            ? parseInt($("body").css("padding-top"), 10)
            : 0;
          // Pin desktop navbar
          var zp_nav = new $.Zebra_Pin($(".pinnedNavbar"), {
            class_name: "navbar-pin",
            z_index: 490,
            top_spacing: adminToolbarHeight
          });

          // Pin mobile navbar
          var zp_nav_mobile = new $.Zebra_Pin($(".pinnedMobileNavbar"), {
            class_name: "navbar-mobile-pin",
            z_index: 490,
            top_spacing: adminToolbarHeight
          });

          // Update zebra pin on resize
          function resize() {
            var hasFixedAdminToolbar = $("body").hasClass("toolbar-fixed");
            var adminToolbarHeight = hasFixedAdminToolbar
              ? parseInt($("body").css("padding-top"), 10)
              : 0;

            // Set updated navbar height on viewport change
            zp_nav.settings.top_spacing = adminToolbarHeight;
            zp_nav.update();

            // Set updated mobile navbar height on viewport change
            zp_nav_mobile.settings.top_spacing = adminToolbarHeight;
            zp_nav_mobile.update();
          }
          function toggle() {
            if (parseInt($("body").css("padding-top"), 10) === 79) {
              zp_nav.settings.top_spacing = 39;
              zp_nav_mobile.settings.top_spacing = 39;
              zp_nav_mobile.update();
              zp_nav.update();
            } else {
              zp_nav.settings.top_spacing = 79;
              zp_nav_mobile.settings.top_spacing = 79;
              zp_nav_mobile.update();
              zp_nav.update();
            }
          }
          // Debounce screen resize event
          window.addEventListener("resize", () => Drupal.debounce(resize, 100));

          // toggle on click event
          $(".toolbar-icon-menu ").on("click", toggle);
        });

        /*
         * Desktop Navigation - Sub-navigation logic
         */
        var primaryNavigationLinks = $(
          ".region-navigation .nav__link.is-top-level"
        );

        $(primaryNavigationLinks, context).on("click keyup", function(e) {
          // Stop event propagation
          e.preventDefault();

          // Target subnav element
          var subnav = $(this)
            .parent()
            .children(".nav__subnav");
          var prevSubnav = $(this)
            .parent()
            .prev()
            .children(".nav__subnav");
          var isNextNavItem = $(this).hasClass("is-top-level", "has-subnav");

          var openSubnavs = primaryNavigationLinks.siblings(".open");
          var currentSubnav = $(this).siblings(".nav__subnav");

          // Hide any subnavs currently open
          $(openSubnavs)
            .not(currentSubnav)
            .removeClass("open");

          // Toggle display (set open class, add aria-hidden: false. Reverse if unselected.)
          subnav.hasClass("open")
            ? subnav.removeClass("open").attr("aria-hidden", "true")
            : subnav.addClass("open").attr("aria-hidden", "false");

          // Hide previous subnav when no longer focused
          isNextNavItem
            ? prevSubnav
                .blur()
                .removeClass("open")
                .attr("aria-hidden", "true")
            : false;
        });

        // When ESC key is pressed, close primary navigation dropdown(s)
        $(document).on("keyup", function(e) {
          var subnavs = $(".region-navigation .navigation").find(
            ".nav__subnav"
          );

          // Close dropdown when ESC is pressed
          if (e.which === 27) {
            subnavs.removeClass("open").attr("aria-hidden", "true");
          }
        });

        // Dynamically open dropdowns to right if too close to edge of screen
        $.each(primaryNavigationLinks, function(index, value) {
          // Nav position
          var elPos = value.getBoundingClientRect();

          // Window position
          var screenPos = $("body")[0].getBoundingClientRect();

          // Subnav dropdown width
          var subnav = $(this).next();
          var subnavWidth = $(this)
            .siblings(".nav__subnav")
            .width();

          // If menu will expand off screen, force menu to right align
          if (elPos.right + subnavWidth > screenPos.right) {
            subnav.addClass("menu-right");
          }
        });

        /*
         * Mobile Navigation - Mobile Menu Button logic
         */
        var mobileNavPanel = $(".region-mobile-navigation__content");
        var mobileNavToggle = $(".togglePanel");

        // When esc key is pressed, close menu
        $(document).on("keyup", function(e) {
          e.which === 27 ? closeMenu() : false;

          // Down arrow press, focus next item
          if (e.which == 39 || e.which == 40) {
            $(":focus")
              .parent()
              .next()
              .children(".nav__link")
              .focus();
          }

          // Up arrow press, focus previous item
          if (e.which == 37 || e.which == 38) {
            $(":focus")
              .parent()
              .prev()
              .children(".nav__link")
              .focus();
          }

          // Hide or show tools menu on focus/blur
          var toolsNav = $(".block--tools");
          var toolsNavButtonHasFocus = $(".block__tools_desktop__title").is(
            ":focus"
          );
          var toolsNavLinkHasFocus = $(".block--tools.desktop .nav__link").is(
            ":focus"
          );
          var toolsNavOpen = $(".block--tools").hasClass("open");

          (toolsNavButtonHasFocus && toolsNavOpen) || toolsNavLinkHasFocus
            ? toolsNav.addClass("open")
            : toolsNav.removeClass("open");
        });

        $(document).on("click", function(e) {
          var menuClick =
            $(e.target).not(primaryNavigationLinks).length > 0 ? true : false;

          if (menuClick) {
            primaryNavigationLinks
              .siblings(".nav__subnav.open")
              .removeClass("open")
              .attr("aria-expanded", false);
          }
        });

        // On mobile, Close the menu if focus is out of the dropdown.
        $(document).on("focusin", function(e) {
          var isFocusInMenu = Boolean(
            $(e.target).parents(".region-mobile-navigation__content").length
          );

          if (!isFocusInMenu && $("body").hasClass("keyboard-focus")) {
            mobileNavToggle.attr("aria-expanded", "false");
            mobileNavPanel.attr("aria-hidden", "true");
            mobileNavPanel.find(".subnav__button").attr("aria-expanded", false);
            mobileNavPanel.find(".nav__subnav").attr("aria-hidden", true);
          }
        });

        // When mobile menu is closed, collapse all navigation items
        $(document).on("mouseup", function(e) {
          // if the target of the click isn't the container nor a descendant of the container
          if (
            !mobileNavPanel.is(e.target) &&
            mobileNavPanel.has(e.target).length === 0
          ) {
            if ($(window).width < 768) {
              closeMenu();
            } else {
              // Get mobile nav items that have been expanded
              mobileNavPanel
                .find(".nav__item.has-subnav.subnav-expanded")
                .removeClass("is-expanded")
                .addClass("is-collapsed")
                .attr("aria-expanded", false);
              mobileNavPanel
                .find(".nav__item.has-subnav .nav__link.subnav-expanded")
                .removeClass("subnav-expanded")
                .addClass("subnav-collapsed")
                .attr("aria-expanded", false);

              mobileNavPanel
                .find(".subnav__button")
                .attr("aria-expanded", false);
              mobileNavPanel.find(".nav__subnav").attr("aria-hidden", true);
            }
          }
        });

        // Set aria-expand value when mobile menu button is selected.
        $(mobileNavToggle).on("click keyup", function(e) {
          var expandedValue = $(this).attr("aria-expanded");
          if (expandedValue == "true") {
            expandedValue = "false";
            closeMenu();
          } else {
            expandedValue = "true";
            openMenu();
          }
          $(this).attr("aria-expanded", expandedValue);
        });

        function openMenu() {
          mobileNavPanel.attr("aria-hidden", "false");
          mobileNavPanel
            .find("> ul:first-of-type > li:first-of-type > a")
            .focus();
          mobileNavToggle.attr("aria-expanded", "true");
          $("body").addClass("no-scroll");
        }

        function closeMenu() {
          mobileNavPanel.find(".block").removeClass("open");
          mobileNavPanel.attr("aria-hidden", "true");
          mobileNavToggle.focus();
          mobileNavToggle.attr("aria-expanded", "false");
          $("body").removeClass("no-scroll");
        }

        /*
         * Tools menu
         */

        // Tools dekstop menu - To expand
        // Dropdown toggle fuction
        $(
          ".block--tools.desktop .block__tools_desktop__title, .block--tools.desktop .nav__link"
        ).on("click keyup", function(e) {
          var block = $(".block--tools.desktop");
          block.hasClass("open")
            ? block.removeClass("open")
            : block.addClass("open");
        });

        // Hide dropdown on page click
        $(document).on("click", function(e) {
          if (
            !$("a.block__tools_desktop__title").is(e.target) &&
            !$("a.block__tools_desktop__title").has(e.target).length
          ) {
            $(".block--tools.desktop").removeClass("open");
          }
        });
        // End tools desktop

        // Search desktop - To expand\
        $(document).on("click", ".nav__search", function(e) {
          e.preventDefault();
          if ($(this).hasClass("open")) {
            $(this).removeClass("open");
            $(".block--search").removeClass("open");
          } else {
            $(this).addClass("open");
            $(".block--search").addClass("open");
          }
        });
        // End Search desktop

        /*
         * Mobile Sub-Panels (Tools, Search)
         */

        $(".toggleSubPanel").on("click", function(e) {
          e.preventDefault();
          var block = $(this).parents(".block");
          block.hasClass("open")
            ? block.removeClass("open")
            : block.addClass("open");
        });

        /*
         * Mobile Navigation -- Sub-Navigation Logic
         */

        $(
          ".region-mobile-navigation__content .nav__link.has-subnav.is-expanded",
          context
        ).each(function() {
          // replace all special characters
          var navTitle = $(this)
            .children("a")
            .text()
            .replace(/[^a-z0-9\s]/gi, "")
            .replace(/[_\s]/g, "-")
            .toLowerCase();
          $(this)
            .children("a")
            .attr("id", "mobile-menu--" + navTitle);

          $(this)
            .children("button")
            .attr("aria-controls", "mobile-menu-accordion--" + navTitle);
          $(this)
            .children("ul")
            .attr({
              id: "mobile-menu-accordion--" + navTitle,
              "aria-labelledby": "mobile-menu--" + navTitle
            });
        });

        $(".subnav__button, .is-top-level.subnav-collapsed", context).on(
          "click keyup",
          function(e) {
            // Stop event propagation
            e.preventDefault();

            // Close other dropdowns
            $(this)
              .parent()
              .siblings(".subnav-expanded")
              .find(".nav__link")
              .attr("aria-expanded", false)
              .removeClass("subnav-expanded")
              .addClass("subnav-collapsed");
            $(this)
              .parent()
              .siblings()
              .find(".nav__subnav")
              .attr("aria-hidden", true);

            var expandedValue = $(this).attr("aria-expanded");

            // Collapse all open items
            var mobileNavItems = $(
              ".region-mobile-navigation__content .navigation"
            );

            $(this)
              .siblings(".nav__item")
              .removeClass("subnav-expanded")
              .addClass("subnav-collapsed")
              .attr("aria-expanded", false)
              .children()
              .removeClass("subnav-expanded")
              .addClass("subnav-collapsed")
              .attr("aria-expanded", false);

            if (expandedValue == "true") {
              expandedValue = "false";
              $(this)
                .siblings("ul")
                .attr("aria-hidden", true);
              $(this)
                .parent(".nav__item")
                .removeClass("subnav-expanded")
                .addClass("subnav-collapsed");
              $(this)
                .removeClass("subnav-expanded")
                .addClass("subnav-collapsed");
            } else {
              expandedValue = "true";
              $(this)
                .siblings("ul")
                .attr("aria-hidden", false);
              $(this)
                .parent(".nav__item")
                .removeClass("subnav-collapsed")
                .addClass("subnav-expanded");
              $(this)
                .removeClass("subnav-collapsed")
                .addClass("subnav-expanded");
            }
            $(this).attr("aria-expanded", expandedValue);
          }
        );
      }
    }
  };
})(jQuery, Drupal, window, document);
